/*
  Stops the Shopify Inbox chat button bouncing.

  The bounce is a nudge-bounce keyframe animation on .activator-nudge, a
  wrapper inside the widget's shadow root. Only the button itself is exposed
  as part="activator", so hme-custom.css can size the button but cannot reach
  the wrapper. The shadow root is open, so the one way in is to append a sheet
  to it from here.

  Polling rather than a MutationObserver: the element is added to the page
  first and its shadow root is attached a beat later, and shadow mutations
  never reach an observer on the document.
*/

(function () {
  const CSS =
    '.activator-nudge, .activator-nudge--active {' +
    ' animation: none !important; translate: none !important; }';

  let sheet;

  function attach() {
    const host = document.querySelector('shopify-chat');
    const root = host && host.shadowRoot;
    if (!root || !('adoptedStyleSheets' in root)) return false;

    if (!sheet) {
      sheet = new CSSStyleSheet();
      sheet.replaceSync(CSS);
    }
    if (!root.adoptedStyleSheets.includes(sheet)) {
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    }
    return true;
  }

  if (attach()) return;

  /* Roughly 60s of 300ms checks, then give up: the app never loaded. */
  let tries = 0;
  const timer = setInterval(function () {
    if (attach() || ++tries > 200) clearInterval(timer);
  }, 300);
})();
